import { usePreferences } from "../../contexts/PreferencesContext";
import React, { useEffect, useRef, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { FaListAlt, FaPlus, FaVideo } from "react-icons/fa";
import { MdDelete, MdModeEdit, MdPrint } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import Search from "../ReusableComponents/Search";
import TableEmptyState from "../ReusableComponents/TableEmptyState";

import { Button, Modal } from "react-bootstrap";
import Request from "../../Request";
import Pagination from '@material-ui/lab/Pagination';
import { BsFillEyeFill } from "react-icons/bs";
import { logout } from "../../actions/AppActions";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";
import ImprimirDiagramacao from "./ImprimirDiagramacao";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";



const Diagramacoes = (props) => {const { t } = usePreferences();

  const [lesson_cards, SetLessonCards] = useState(null);
  const [loading_screen, setLoadingScreen] = useState(true);
  const [loading_diagramacoes, setLoadingdiagramacoes] = useState(false);
  const [search_oficial, setSearchOficial] = useState('');

  const [diagramacoes, setdiagramacoes] = useState([]);
  const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });



  const [search, setSearch] = useState('');
  const { processo_id, processo_name } = props;
  const [show_warning, setShowWarning] = useState(false);
  const [diagramacao_id, setRedacaoId] = useState(null);
  const [diagramacaoSelect, setDiagramacaoSelect] = useState(null);



  const [questaoSelect, setQuestaoSelect] = useState({});

  const [showModal, setShowModal] = useState(false);
  let refs = [];
  const dispatch = useDispatch();
  const location = useLocation();

  const Getdiagramacoes = async (page, search) => {

    let response = await Request.Get(user.role == 'viwer' ? `faculdade/get_diagramacoes_all?page=${page}&search=${search}` : `faculdade/get_diagramacoes/${processo_id}?page=${page}&search=${search}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    if (response.pagination.current_page == page) {
      let diagramacao_id = new URLSearchParams(location.search).get('diagramacao_id');
      let diagramacao = [...response.diagramacoes.filter((item, id) => item.id == diagramacao_id)];

      setdiagramacoes(response.diagramacoes);

      setPagination(response.pagination);
      setLoadingScreen(false);
      setLoadingdiagramacoes(false);
      if (diagramacao.length > 0) {
        console.log(diagramacao);

        setDiagramacaoSelect(diagramacao[0]);
        setShowModal(true);
        history.push({ search: '?tab=2' });


      }


    }
  };

  const DeleteRedacao = async (diagramacao_id) => {

    let response = await Request.Delete(`faculdade/delete_diagramacao/${diagramacao_id}`);
    console.log(response);
    if (response === undefined) return;

    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    Getdiagramacoes(pagination.current_page, search_oficial);



  };

  useEffect(() => {
    Getdiagramacoes(1, search_oficial);
  }, []);
  const user = useSelector((state) => state.AppReducer.user);

  let pesquisarTimeout = null;
  const history = useHistory();
  console.log('select', diagramacaoSelect);
  return (
    <>

            <div className={user.role == 'viwer' ? "card" : ''}>
                <div className={user.role == 'viwer' ? "card-body" : ''} id="card">

                    {user.role == 'viwer' && <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>{t("legacy_lista_de_diagramacoes")}</h4>}


                    {/* <hr /> */}
                    {loading_screen == false && <div>
                        <div className="module-card-container">

                            <div className="module-breadcrumb">

                                <button
                  className="breadcrumb-back"
                  onClick={() =>
                  props.setState({
                    activeTab: -1
                  })
                  }>{t("dashboard")}


                </button>

                                <span>/</span>

                                <strong>{t("diagramLayouts")}</strong>

                            </div>

                            <div className="module-title-row">

                                <div>

                                    <h3 style={{ fontWeight: 'bold' }}>{`
                                        ${t("diagramLayouts")}
                                    `}</h3>

                                    <p>{`
                                        ${t("legacy_gerencie_as_diagramacoes_vinculadas_ao_processo")}
                                    `}</p>

                                </div>

                                <button
                  className="btn-dashboard-modern"
                  onClick={() =>
                  props.setState({
                    activeTab: -1
                  })
                  }>{`
                                    ${t("legacy_dashboard")}
                                `}
                </button>

                            </div>
                            {/* <h4 className="mt-0 header-title" style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>Questões</h4> */}
                            {/* <br /> */}
                            {<div className="hidethis">
                                <div className="module-toolbar">

                                    <Search
                    placeholder={t("legacy_pesquisar_pelo_nome_da_diagramacao")}
                    ValueChange={(value) => {

                      clearTimeout(pesquisarTimeout);

                      setSearchOficial(value);

                      pesquisarTimeout = setTimeout(() => {

                        let page = { ...pagination };

                        page.current_page = 1;

                        setPagination(page);

                        setLoadingdiagramacoes(true);

                        Getdiagramacoes(1, value);

                      }, 500);

                    }} />


                                    {user.role !== 'viwer' &&

                  <Link
                    to={`/diagramacoes/register/${processo_id}`}
                    className="btn-module-primary">


                                            <FaPlus />{t("ui_nova_diagramacao_3f8a792f")}



                  </Link>

                  }

                                </div>
                            </div>}


                            <div className="table-modern-card">
                                <table id="tech-companies-1" className="table table-striped">
                                    <thead>
                                        <tr>

                                            <th>{t("legacy_titulo")}</th>
                                            <th>{t("label_name")}</th>
                                            <th>{t("legacy_numero_de_colunas")}</th>
                                            <th data-priority="3">{t("label_actions")}</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading_diagramacoes == false && diagramacoes.map((item, id) =>

                    <tr key={id}>
                                                <td> <div className="redacao-name">

                                                    <strong>
                                                        {item.titulo_pagina}
                                                    </strong>

                                                </div></td>
                                                <td>

                                                    <div className="redacao-preview">

                                                        {item.nome_prova}

                                                    </div>

                                                </td>
                                                <td>

                                                    <div className="redacao-preview">

                                                        {item.numero_colunas} colunas

                                                    </div>

                                                </td>
                                                {/* <td><img style={{ height: 60, width: 60, objectFit: 'contain' }} src={STORAGE_URL + STORAGE_URL + item.arquivo} /></td> */}

                                                <td>

                                                    <div className="actions-group">

                                                        <button
                            className="action-btn success"
                            onClick={(e) => {

                              e.stopPropagation();

                              setShowModal(true);

                              setDiagramacaoSelect(item);

                            }}>

                                                            <MdPrint />
                                                        </button>

                                                        {user.role !== 'viwer' &&

                          <>

                                                                <Link to={`/diagramacoes/show/${item.id}`}>

                                                                    <button
                                className="action-btn warning">

                                                                        <BsFillEyeFill />
                                                                    </button>

                                                                </Link>

                                                                <Link to={`/diagramacoes/edit/${item.id}`}>

                                                                    <button
                                className="action-btn info">

                                                                        <MdModeEdit />
                                                                    </button>

                                                                </Link>

                                                                <button
                              className="action-btn danger"
                              onClick={() => {

                                setRedacaoId(item.id);

                                setShowWarning(true);

                              }}>

                                                                    <MdDelete />
                                                                </button>

                                                            </>

                          }

                                                    </div>

                                                </td>
                                            </tr>
                    )}

                                    </tbody>
                                </table>
                                {loading_diagramacoes == true &&
                <div className="row" style={{ margin: 0 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                                        {/* <div className="spinner-border text-primary" role="status"  >
                      </div> */}
                                        <CircularProgress />
                                    </div></div>

                }
                            </div>
                            {loading_diagramacoes == false && diagramacoes.length == 0 && <TableEmptyState title={t("empty_no_layout_found")} description={t("ui_cadastre_a_primeira_diagramacao_deste_processo_921ee032")} icon="📄" />}

                            <Pagination
                className={pagination.last_page == 1 ? "hide hidethis" : "hidethis "}
                style={{ display: "flex", justifyContent: "flex-end" }}
                count={pagination.last_page}
                value={pagination.current_page}
                onChange={(_, value) => {
                  setLoadingdiagramacoes(true);
                  console.log(_, value);
                  let page = { ...pagination };
                  page.current_page = value;
                  setPagination(pagination);
                  Getdiagramacoes(value, search_oficial);
                }} />

                            <Modal
                show={showModal == true}
                dialogClassName="modal_width_full"
                onHide={() => setShowModal(false)}>

                                <Modal.Header closeButton>
                                    {/* <Modal.Title>Modal title</Modal.Title> */}
                                </Modal.Header>
                                <Modal.Body>
                                    {showModal == true && <ImprimirDiagramacao isModal={true} showModal={showModal} setShowModal={(e) => setShowModal(e)} diagramacao={diagramacaoSelect} />}

                                </Modal.Body>

                            </Modal>

                            {/* {this.state.andamento == true && <AvaliacaoAndamento get_diagramacao={this.get_diagramacao.bind(this)} {...this.props} />} */}
                            {/* <ImprimirDiagramacao isModal={false} showModal={showModal} setShowModal={(e) => setShowModal(e)} diagramacao={diagramacaoSelect} /> */}
                        </div>

                    </div>}

                    {loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                        {/* <div className="spinner-border text-primary" role="status"  >
                </div> */}
                        <CircularProgress />
                    </div></div>}


                    <SweetAlert
            warning
            title={t("legacy_atencao")}
            onConfirm={() => {
              setShowWarning(false);
              setLoadingdiagramacoes(true);
              DeleteRedacao(diagramacao_id);
              // this.delete_banner(this.state.banner_to_delete);
            }}
            onCancel={() => {
              setShowWarning(false);
            }}
            show={show_warning}
            confirmBtnText={t("legacy_sim_desejo_apagar")}
            cancelBtnText={t("legacy_cancelar")}
            confirmBtnBsStyle="success"
            cancelBtnBsStyle="danger"
            showCancel={true}>{t("ui_ao_deletar_esta_diagramacao_ele_nao_estara_mais_di_596f476a")}


          </SweetAlert>

                </div>
            </div>


        </>);

};

export default Diagramacoes;
